import apiClient, { makeQueryString, WrappingApiClient } from 'libs/api/apiClient';
import {
  TRequestCaseList,
  TRequestCaseExplain,
  TRequestMenteeCaseList,
  TRequestMentorCaseList,
  TRequestLibraryList,
  TRequestLibraryReply,
  TRequestAddMenteeAnswer,
  TRequestAddLibrary,
  TRequestQNAList,
  TRequestAddQNA,
} from 'modules/case/types';
import { TSendSMS, TReceiveSMS } from 'modules/user';

/**
 * Case 스터디
 */

export const getCaseList = (params: TRequestCaseList) => {
  return WrappingApiClient(apiClient.get(`/products/?${makeQueryString(params)}`));
};

export const getCaseSeason = () => {
  return WrappingApiClient(apiClient.get('/products/season'));
};

export const getCaseItem = (id: number | string) => {
  return WrappingApiClient(apiClient.get(`/products/question/${id}`));
};

export const postRecommendCase = (id: number, is_satisfied: boolean) => {
  return WrappingApiClient(
    apiClient.post(
      `/products/satisfaction/${id}?${makeQueryString({
        is_satisfied: is_satisfied ? 'True' : 'False',
      })}`,
    ),
  );
};
export const getCasePrice = (id: number | string, params: TRequestCaseExplain) => {
  return WrappingApiClient(apiClient.get(`/products/package/${id}?${makeQueryString(params)}`));
};
export const getMentorAnswerPrice = (id: number) => {
  return WrappingApiClient(apiClient.get(`/products/payment/${id}`));
};
//결제하기 눌렀을 때 이니시스 창 뜰 때 실행 (거래 로그 생성 endpoint)
export const createPaymentLog = (
  params: {
    pay_method: string;
    mentor_answer?: Array<string>;
    credit?: number;
    amount?: number;
    is_drill_membership?: boolean;
    mentoring_ticket_id?: number;
    is_mentor_answer_package?: boolean;
    is_excel_video_lecture?: boolean;
    is_interview_master_class_basic?: boolean;
  },
  type?: string,
) => {
  if (!!type) {
    return WrappingApiClient(apiClient.post(`/credit/payment/create?item=${type}`, params));
  } else {
    return WrappingApiClient(apiClient.post('/credit/payment/create', params));
  }
};
//결제 요청 성공 시(if (rsp.success)) 실행(결제 완료되었을 때)
//서버는 클라이언트로 부터 결제 정보를 수신한 후에 해당 거래의 결제금액의 위변조 여부를 검증하고 결제 정보를 데이터베이스에 저장하기 위해
//결제 번호(imp_uid)와 주문번호(merchant_uid)를 전달받는 API endpoint
export const completePayment = (params: { imp_uid: string; merchant_uid: string }) => {
  return WrappingApiClient(apiClient.post('/products/credit/', params));
};
export const checkPaidExplain = (id: number) => {
  return WrappingApiClient(apiClient.get(`/products/payed/${id}`));
};

export const getCaseMentorExplain = (id: number | string, params: TRequestMentorCaseList) => {
  return WrappingApiClient(apiClient.get(`/products/${id}?${makeQueryString(params)}`));
};
export const getCaseStepExplain = (id: number | string) => {
  return WrappingApiClient(apiClient.get(`/products/careerstep_answer/${id}`));
};
export const getCaseMenteeExplain = (id: number | string, params: TRequestMenteeCaseList) => {
  return WrappingApiClient(apiClient.get(`/menteeanswers/${id}?${makeQueryString(params)}`));
};

export const getCaseExplainDetail = (id: number | string) => {
  return WrappingApiClient(apiClient.get(`/products/answer_detail/${id}`));
};
export const getCaseMenteeExplainDetail = (id: number | string) => {
  return WrappingApiClient(apiClient.get(`/menteeanswer/detail/${id}`));
};

export const delCaseMenteeExplainDetail = (id: number | string) => {
  return WrappingApiClient(apiClient.delete(`/menteeanswers/${id}`));
};

export const getCaseReply = (
  id: number | string,
  isSub: boolean,
  params?: { pageSize: number; current: number },
) => {
  if (isSub) return WrappingApiClient(apiClient.get(`/question/comment_review/${id}`));
  else return WrappingApiClient(apiClient.get(`/question/comment/${id}?${makeQueryString(params)}`));
};
export const getCaseMentorReply = (
  id: number | string,
  isSub: boolean,
  params: { pageSize: number; current: number },
) => {
  if (isSub) return WrappingApiClient(apiClient.get(`/mentoranswer/comment_review/${id}`));
  else return WrappingApiClient(apiClient.get(`/mentoranswer/comment/${id}?${makeQueryString(params)}`));
};
export const getCaseMenteeReply = (
  id: number | string,
  isSub: boolean,
  params: { pageSize: number; current: number },
) => {
  if (isSub) return WrappingApiClient(apiClient.get(`/menteeanswer/comment_review/${id}`));
  else return WrappingApiClient(apiClient.get(`/menteeanswer/comment/${id}?${makeQueryString(params)}`));
};

export const createCaseReply = (id: number | string, content: string, isSub: boolean) => {
  if (isSub) return WrappingApiClient(apiClient.post(`/question/comment_review/${id}`, { content }));
  else return WrappingApiClient(apiClient.post(`/question/comment/${id}`, { content }));
};
export const createCaseMentorReply = (id: number | string, content: string, isSub: boolean) => {
  if (isSub) return WrappingApiClient(apiClient.post(`/mentoranswer/comment_review/${id}`, { content }));
  else return WrappingApiClient(apiClient.post(`/mentoranswer/comment/${id}`, { content }));
};
export const createCaseMenteeReply = (id: number | string, content: string, isSub: boolean) => {
  if (isSub) return WrappingApiClient(apiClient.post(`/menteeanswer/comment_review/${id}`, { content }));
  else return WrappingApiClient(apiClient.post(`/menteeanswer/comment/${id}`, { content }));
};
export const updateCaseReply = (id: number | string, content: string, isSub: boolean) => {
  if (isSub) return WrappingApiClient(apiClient.put(`/question/comment_review/${id}`, { content }));
  else return WrappingApiClient(apiClient.put(`/question/comment/${id}`, { content }));
};
export const updateCaseMentorReply = (id: number | string, content: string, isSub: boolean) => {
  if (isSub) return WrappingApiClient(apiClient.put(`/mentoranswer/comment_review/${id}`, { content }));
  else return WrappingApiClient(apiClient.put(`/mentoranswer/comment/${id}`, { content }));
};
export const updateCaseMenteeReply = (id: number | string, content: string, isSub: boolean) => {
  if (isSub) return WrappingApiClient(apiClient.put(`/menteeanswer/comment_review/${id}`, { content }));
  else return WrappingApiClient(apiClient.put(`/menteeanswer/comment/${id}`, { content }));
};

export const likeCaseReply = (id: number, isLike: boolean, isSub: boolean) => {
  if (isSub)
    return WrappingApiClient(
      apiClient.post(
        `/question/comment_review_like/${id}?${makeQueryString({
          is_like: isLike ? 'True' : 'False',
        })}`,
      ),
    );
  else
    return WrappingApiClient(
      apiClient.post(
        `/question/comment_like/${id}?${makeQueryString({
          is_like: isLike ? 'True' : 'False',
        })}`,
      ),
    );
};
export const likeCaseMentorReply = (id: number, isLike: boolean, isSub: boolean) => {
  if (isSub)
    return WrappingApiClient(
      apiClient.post(
        `/mentoranswer/comment_review_like/${id}?${makeQueryString({
          is_like: isLike ? 'True' : 'False',
        })}`,
      ),
    );
  else
    return WrappingApiClient(
      apiClient.post(
        `/mentoranswer/comment_like/${id}?${makeQueryString({
          is_like: isLike ? 'True' : 'False',
        })}`,
      ),
    );
};
export const likeCaseMenteeReply = (id: number, isLike: boolean, isSub: boolean) => {
  if (isSub)
    return WrappingApiClient(
      apiClient.post(
        `/menteeanswer/comment_review_like/${id}?${makeQueryString({
          is_like: isLike ? 'True' : 'False',
        })}`,
      ),
    );
  else
    return WrappingApiClient(
      apiClient.post(
        `/menteeanswer/comment_like/${id}?${makeQueryString({
          is_like: isLike ? 'True' : 'False',
        })}`,
      ),
    );
};

export const delCaseReply = (id: number, isSub: boolean) => {
  if (isSub) return WrappingApiClient(apiClient.delete(`/question/comment_review/${id}`));
  else return WrappingApiClient(apiClient.delete(`/question/comment/${id}`));
};
export const delCaseMentorReply = (id: number, isSub: boolean) => {
  if (isSub) return WrappingApiClient(apiClient.delete(`/mentoranswer/comment_review/${id}`));
  else return WrappingApiClient(apiClient.delete(`/mentoranswer/comment/${id}`));
};
export const delCaseMenteeReply = (id: number, isSub: boolean) => {
  if (isSub) return WrappingApiClient(apiClient.delete(`/menteeanswer/comment_review/${id}`));
  else return WrappingApiClient(apiClient.delete(`/menteeanswer/comment/${id}`));
};

export const ratingCaseMentor = (id: number, rating: number) => {
  return WrappingApiClient(apiClient.post(`/products/answer_rating/${id}?${makeQueryString({ rating })}`));
};
export const ratingCaseMentee = (id: number, rating: number) => {
  return WrappingApiClient(apiClient.post(`/menteeanswer/rating/${id}?${makeQueryString({ rating })}`));
};

export const saveMenteeAnswer = (id: number | string, params: TRequestAddMenteeAnswer, isUpdate = false) => {
  if (isUpdate) return WrappingApiClient(apiClient.put(`/menteeanswers/${id}`, params));
  else return WrappingApiClient(apiClient.post(`/menteeanswers/${id}`, params));
};

export const getLibraryList = (params: TRequestLibraryList) => {
  return WrappingApiClient(apiClient.get(`/library/?${makeQueryString(params)}`));
};
export const getLibraryItem = (id: number | string) => {
  return WrappingApiClient(apiClient.get(`/caselibrary/${id}`));
};
export const delLibraryItem = (id: number | string) => {
  return WrappingApiClient(apiClient.delete(`/caselibrary/${id}`));
};
export const bookmarkLibrary = (id: number) => {
  return WrappingApiClient(apiClient.post(`/library/bookmark/${id}`));
};
export const getLibraryReply = (id: number | string, isSub: boolean, params: TRequestLibraryReply) => {
  if (isSub) return WrappingApiClient(apiClient.get(`/library/comment_review/${id}`));
  else return WrappingApiClient(apiClient.get(`/library/comment/${id}?${makeQueryString(params)}`));
};
export const createLibraryReply = (id: number | string, content: string, isSub: boolean) => {
  if (isSub) return WrappingApiClient(apiClient.post(`/library/comment_review/${id}`, { content }));
  else return WrappingApiClient(apiClient.post(`/library/comment/${id}`, { content }));
};
export const updateLibraryReply = (id: number | string, content: string, isSub: boolean) => {
  if (isSub) return WrappingApiClient(apiClient.put(`/library/comment_review/${id}`, { content }));
  else return WrappingApiClient(apiClient.put(`/library/comment/${id}`, { content }));
};
export const likeLibraryReply = (id: number, isLike: boolean, isSub: boolean) => {
  if (isSub)
    return WrappingApiClient(
      apiClient.post(
        `/library/comment_review/like/${id}?${makeQueryString({
          is_like: isLike ? 'True' : 'False',
        })}`,
      ),
    );
  else
    return WrappingApiClient(
      apiClient.post(
        `/library/comment/like/${id}?${makeQueryString({
          is_like: isLike ? 'True' : 'False',
        })}`,
      ),
    );
};
export const recommendLibary = (id: number | string, isGood: boolean) => {
  return WrappingApiClient(
    apiClient.post(
      `/library/satisfaction/${id}?${makeQueryString({
        is_good: isGood ? 'True' : 'False',
      })}`,
    ),
  );
};
export const delLibraryReply = (id: number, isSub: boolean) => {
  if (isSub) return WrappingApiClient(apiClient.delete(`/library/comment_review/${id}`));
  else return WrappingApiClient(apiClient.delete(`/library/comment/${id}`));
};
export const saveLibrary = (params: TRequestAddLibrary, id?: number) => {
  if (id) return WrappingApiClient(apiClient.put(`/caselibrary/${id}`, params));
  else return WrappingApiClient(apiClient.post(`/caselibrary/`, params));
};

export const getLibraryCompany = () => {
  return WrappingApiClient(apiClient.get('/library/company_list/'));
};

export const sendCode = (params: TSendSMS) => {
  return WrappingApiClient(
    apiClient.post(`/notification/sms/send_verification?mentor_answer=mentor_answer`, params),
  );
};

export const verifyCode = (params: TReceiveSMS) => {
  return WrappingApiClient(apiClient.post(`/notification/sms/receive_verification`, params));
};

export const IntroductionPageHitCount = () => {
  return WrappingApiClient(apiClient.get('/products/case/hitcount/1'));
};

export const sampleCaseNoteHitCount = () => {
  return WrappingApiClient(apiClient.get('/products/sample/hitcount/1'));
};

//케이스 Q&A
export const getCaseQNACompany = () => {
  return WrappingApiClient(apiClient.get('/library/company_list/'));
};

export const getQNACategory = () => {
  return WrappingApiClient(apiClient.get('/library/qna/category'));
};

export const getQNASubcategory = () => {
  return WrappingApiClient(apiClient.get('/library/qna/sub_category'));
};

export const getQNAList = (params: TRequestQNAList) => {
  return WrappingApiClient(apiClient.get(`/library/qnas/?${makeQueryString(params)}`));
};

export const getQNAItem = (id: number | string) => {
  return WrappingApiClient(apiClient.get(`/library/qna/${id}`));
};

export const delQNAItem = (id: number | string) => {
  return WrappingApiClient(apiClient.delete(`/library/qna/${id}`));
};

//댓글 & 대댓글 리스트 get
export const getQNAReply = (id: number | string, isSub: boolean, params: TRequestLibraryReply) => {
  if (isSub) return WrappingApiClient(apiClient.get(`/library/qna/reply/${id}`));
  else return WrappingApiClient(apiClient.get(`/library/qna/comment/${id}?${makeQueryString(params)}`));
};

//댓글 & 대댓글 쓰기 post
export const createQNAReply = (id: number | string, content: string, isSub: boolean) => {
  if (isSub) return WrappingApiClient(apiClient.post(`/library/qna/reply/${id}`, { content }));
  else return WrappingApiClient(apiClient.post(`/library/qna/comment/${id}`, { content }));
};

//댓글 & 대댓글 수정
export const updateQNAReply = (id: number | string, content: string, isSub: boolean) => {
  if (isSub) return WrappingApiClient(apiClient.put(`/library/qna/reply/${id}`, { content }));
  else return WrappingApiClient(apiClient.put(`/library/qna/comment/${id}`, { content }));
};

export const likeQNAReply = (id: number) => {
  return WrappingApiClient(apiClient.get(`/library/qna/comment_like/${id}`));
};

//댓글 & 대댓글 삭제
export const delQNAReply = (id: number, isSub: boolean) => {
  if (isSub) return WrappingApiClient(apiClient.delete(`/library/qna/reply/${id}`));
  else return WrappingApiClient(apiClient.delete(`/library/qna/comment/${id}`));
};

//id 가 있다는 얘기는 이미 있는 글을 수정한다는 것(put) id가 없다는 것은 초기 글쓰기(post)
export const saveQNA = (params: TRequestAddQNA, id?: number, field?: string) => {
  if (id) return WrappingApiClient(apiClient.put(`/library/qna/${id}`, params));
  else
    return WrappingApiClient(
      apiClient.post(`/library/qna/?${makeQueryString({ mentoring_field: field })}`, params),
    );
};
